module.exports = __webpack_public_path__ + "static/media/orange-button.05a09b93.png";